export default __webpack_public_path__ + "static/media/review_grey.e070fcfd.svg";